import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propBool, propFunc, propShape, } from '../../../../../../helpers/custom-prop-types';
import SubmitButton from '../../../../../Ui/Button/SubmitButton';
const InterviewDownload = (props) => {
    const { dispatch, hasSelect, offers, rfp, unmountRef, useCase } = props;
    const { downloading, onClickDownload } = useCase.useDownload(rfp, offers, dispatch, unmountRef);
    return (_jsx("div", Object.assign({ className: clsx('download_all_offer_box', hasSelect && 'has_select') }, { children: _jsx(SubmitButton, { buttonType: 'button', className: 'download_all_offer', isDisabled: downloading, isLoading: downloading, onClick: onClickDownload, text: _jsxs(_Fragment, { children: [_jsx("span", { children: "\u63D0\u6848\u5185\u5BB9\u3092\u4E00\u62EC\u3067\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B" }), _jsx("i", { className: 'material-icons get_app' })] }), value: rfp.id }) })));
};
InterviewDownload.propTypes = {
    dispatch: propFunc().isRequired,
    hasSelect: propBool().isRequired,
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
    unmountRef: propShape().isRequired,
    useCase: propShape().isRequired,
};
export default InterviewDownload;
